import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getCOURSERLOCMAPTableStructure";
export const UPDATE_TABLE_DATA = "getCOURSERLOCMAPTableData";
export const EXPORT_TABLE_DATA = "exportCOURSERLOCMAPTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setCOURSERLOCMAPTableStructure";
export const SET_TABLE_DATA = "setCOURSERLOCMAPTableData";
export const SET_TABLE_FILTER = "setCOURSERLOCMAPTableFilter";
export const SET_TABLE_PAGE = "setCOURSERLOCMAPTablePage";
export const SET_TABLE_PERPAGE = "setCOURSERLOCMAPTablePerPage";
export const SET_TABLE_SORTBY = "setCOURSERLOCMAPTableSortBy";
export const SET_TABLE_SORTORDER = "setCOURSERLOCMAPTableSortOrder";
export const SET_EXPORT_LINK = "setCOURSERLOCMAPExportLink";
export const SET_SERVER_DATA = "setCOURSERLOCMAPServerData";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  serverData: null, // only for organization
};

const getters = {
  /**
   * for table title, descripton
   * */
  getCOURSERLOCMAPTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getCOURSERLOCMAPTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getCOURSERLOCMAPTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },

  getCOURSERLOCMAPTableHeaders(state) {
    return state.table_structure.columns;
  },

  getCOURSERLOCMAPTableFilters(state) {
    return state.table_structure.filters;
  },

  getCOURSERLOCMAPTableData(state) {
    return state.table_data.data;
  },

  getCOURSERLOCMAPExportUrl(state) {
    return state.export_link;
  },
  getCOURSERLOCMAPUploadType(state) {
    return state.table_structure.type;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/shipping/carrier_service_location_mappings")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/shipping/carrier_service_location_mappings/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/shipping/carrier_service_location_mappings/export",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_SERVER_DATA](state, data) {
    state.serverData = data;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
